import { NavigationInstruction, Next } from 'aurelia-router';

export abstract class RouterAuthorizeStepProvider {
    public abstract run(navigationInstruction: NavigationInstruction, next: Next): Promise<any>
}